module.exports = __webpack_public_path__ + "static/media/main_bg.e5d54c0b.png";